module.exports = __webpack_public_path__ + "static/img/qr-head.98c31d32.jpg";